import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", {
    class: "footer-container",
    style: _normalizeStyle({ height: _ctx.height + 'px' })
  }, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"footer-content\" data-v-1c76f42e><div class=\"footer-row2\" data-v-1c76f42e><span class=\"copyright\" data-v-1c76f42e>© zimimodel.com</span></div><div class=\"footer-row3\" data-v-1c76f42e><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" class=\"footer-record\" data-v-1c76f42e> 闽ICP备2025113434号-1 </a></div></div>", 1)
  ]))], 4))
}